import AlertPage from "components/common/AlertPage";
import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { Alert } from "react-ionicons";

const Forbidden = () => {
  return (
    <div className="page-content">
      <Helmet>
        <title>Accès interdit</title>
        <meta name="description" content="Vous ne disposez pas des droits nécessaires pour visualiser cette page." />
        <meta property="og:title" content="Accès interdit" />
        <meta property="og:description" content="Vous ne disposez pas des droits nécessaires pour visualiser cette page." />
        <meta property="og:type" content="website" />
      </Helmet>
      <AlertPage title={"Accès interdit"} description={"Vous ne disposez pas des droits nécessaires pour visualiser cette page."} />
    </div>
  );
};

export default Forbidden;
